import clsx from 'clsx';
import * as React from 'react';
import { Fragment } from 'react';
import FilterStore from '../Store';
import { observer } from 'mobx-react';
import { FilterOptions } from '../Types';
import DropdownItem from './DropdownItem';
import { Menu, Transition } from '@headlessui/react';

interface Props {
  filterStore: FilterStore;
  options: FilterOptions[];
}

const Dropdown: React.FC<Props> = ({ filterStore, options }) => (
  <Transition
    as={Fragment}
    enter="transition ease-out duration-100"
    enterFrom="transform opacity-0 scale-95"
    enterTo="transform opacity-100 scale-100"
    leave="transition ease-in duration-75"
    leaveFrom="transform opacity-100 scale-100"
    leaveTo="transform opacity-0 scale-95"
  >
    <Menu.Items
      className={clsx(
        'mt-2 rounded-md border-1 bg-white drop-shadow-md',
        'absolute z-[3] border-solid border-gray-300 py-2 pl-2 pr-1',
      )}
    >
      <div className="relative max-h-96 overflow-scroll overflow-x-hidden py-1">
        {options.map((option) => (
          <DropdownItem key={option.value} option={option} filterStore={filterStore} />
        ))}
      </div>
    </Menu.Items>
  </Transition>
);

export default observer(Dropdown);
